module.exports = __webpack_public_path__ + "img/menucn_3_1.62e83296.svg";